import { ReactNode } from "react";
import { SDBasketType } from "../../db";
import { ContextOrderBasketType } from "../../hooks";

import type { DraftOrdersListResponseType } from "@sellar-io/api-v2/types";
import { UnifiedCheckoutContext } from "./UnifiedCheckoutProvider.shared";

export type SupplierStorefrontInfo = DraftOrdersListResponseType[number];

export type UnifiedCheckoutContextApi = {
  sdBasket: SDBasketType;
  sdOrders: ContextOrderBasketType[];
  supplierInfoMap: Map<number, SupplierStorefrontInfo>;
  isLoading: boolean;
  updateBasket: (_updates: Partial<SDBasketType>) => Promise<void>;
};

UnifiedCheckoutContext.displayName = "UnifiedCheckoutContext";

type UnifiedCheckoutProviderProps = {
  sdBasket: SDBasketType;
  sdOrders: ContextOrderBasketType[];
  supplierInfoMap: Map<number, SupplierStorefrontInfo>;
  isLoading: boolean;
  updateBasket: (_updates: Partial<SDBasketType>) => Promise<void>;
  children: ReactNode;
};

export const UnifiedCheckoutProvider = (
  value: UnifiedCheckoutProviderProps,
) => (
  <UnifiedCheckoutContext.Provider value={value}>
    {value.children}
  </UnifiedCheckoutContext.Provider>
);
